import { AxiosService } from 'src/services/AxiosService';
import { CodeType } from 'src/contracts/codeType';
import { DrgAnalysisCode } from 'src/contracts/drgAnalysis';
import { AnalyseCode } from 'src/contracts/drgAnalyseResponseDto';
import { GrouperServiceConverter } from 'src/services/converters/GrouperServiceConverter';

export type SearchHistory = string[];
export class SearchService extends AxiosService {

  async searchCodes(token: string, codeType: CodeType): Promise<DrgAnalysisCode[]> {
    const url = `/grouper/search/${encodeURIComponent(this.visitId)}/${encodeURIComponent(codeType === CodeType.Diagnosis ? 'DIAGNOSIS' : 'PROCEDURE')}?token=${encodeURIComponent(token)}`;
    console.log(`search url: ${url}`);
    console.dir(this.axiosInstance);
    const result =  await this.axiosCall<AnalyseCode[]>({
      method: 'get',
      url
    });

    if (result.err) {
      console.log(`[GrouperService] Error: ${(<Error>result.err).message}`);
      throw new Error((<Error>result.err).message);
    }

    return <DrgAnalysisCode[]>GrouperServiceConverter.convertCodes(<AnalyseCode[]>result.data);
  }

  async addSearchHistory(term?: string) {
    const result =  await this.axiosCall<SearchHistoryResult>({
      method: term ? 'post' : 'get',
      url: '/iodine-grouper-preference/search-history',
      params: {searchText: term ?? ''}
    });

    if (result.err) {
      throw new Error((<Error>result.err).message);
    }

    return result?.data?.searchHistoryItems ?? [];
  }

  public async getCodebooksSearch(book: string, term: string, date: string): Promise<SearchViewRecord[] | []> {
    const result =  await this.axiosCall<CodebookTermSearchResponse>({
        method: 'get',
        url: `/grouper/${encodeURIComponent(this.facilityCode)}/codebook/book/${encodeURIComponent(book)}/search/${encodeURIComponent(term)}`,
        params: {date: date, max_results: 35}
      });

    if (result.err) {
      throw new Error((<Error>result.err).message);
    }

    return result?.data?.search_view_records || [];
  }
  public async getCodebooksDetails(book: string, sequenceId: number, date: string): Promise<BookViewRecord[] | undefined> {

    const result =  await this.axiosCall<CodebookDetailResponse>({
      method: 'get',
      url: `/grouper/${encodeURIComponent(this.facilityCode)}/codebook/book/${encodeURIComponent(book)}/details/${encodeURIComponent(sequenceId)}`,
      params: {date: date, records: 50}
    });

    if (result.err) {
      throw new Error((<Error>result.err).message);
    }

    return result?.data?.book_view_records;
  }

  public async getCodebooksPCSTable(code: string, date: string){
    const result =  await this.axiosCall<CodebookPCSTableResponse>({
      method: 'get',
      url: `/grouper/${encodeURIComponent(this.facilityCode)}/codebooks/pcs-table/${encodeURIComponent(code)}`,
      params: {date: date}
    });
    if (result.err) {
      throw new Error((<Error>result.err).message);
    }

    return result?.data;
  }
}

export interface CodebookTermSearchResponse {
  search_type: string,
  data_book: string,
  data_date: string,
  requested_term: string,
  search_term: string,
  search_view_records: SearchViewRecord[],
  search_view_tabular_records: SearchViewTabularRecord[],
  valid_partial_code: string
}

export interface SearchViewRecord {
  data_id: number,
  data_sequence: number,
  data_book: string,
  data_date: string,
  text: string,
  codes: string[],
  type: string
}

export interface SearchViewTabularRecord {
  data_id: number,
  data_sequence: number,
  data_book: string,
  data_date: string
}

export interface CodebookDetailResponse {
  data_book: string,
  data_date: string,
  data_book_title: string,
  data_book_year: number,
  book_view_records: BookViewRecord[]
}

export interface BookViewRecord {
  data_id: number,
  data_sequence: number,
  data_book: string,
  data_date: string,
  record: BookViewRecordEntry
}

export interface BookViewRecordEntry {
  type: string,
  level: number,
  hasinstructionalnotes: boolean,
  subtypes: Subtype[],
  regular_row_codes: string[]
  codes: Code[],
  instructional_note_data: InstructionalNoteData,
  content: string,
  hccs: Hcc[],
  regular_note_data: RegularNoteData
}

export interface Code {
  startCode: string
}

export interface Subtype {
  name: string
}

export interface InstructionalNoteData {
  type: string,
  segments: Segment[]
}

export interface Hcc {
  hcc: number,
  description: string,
  version: string
}

export interface RegularNoteData {
  segments: Segment[]
}

export interface Segment {
  type: string,
  level: number,
  content: string
}

export interface CodebookPCSTableResponse {
  columns: Column[],
  section_title: string,
  data_book_title: string,
  data_book_year: string
}

export interface Column {
  index: number,
  choices: Choice[],
  header: string
}

export interface Choice {
  char: string,
  label: string,
  prefixes: string[],
  definition: string
}

export interface SearchHistoryResult {
  searchHistoryItems: SearchHistory
}
